module.exports = __webpack_public_path__ + "media/images/athletes/531-c87088263ca626f6c075a298eb118f25.png";